"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePostHog = void 0;
const router_1 = require("next/router");
const posthog_js_1 = __importDefault(require("posthog-js"));
const react_1 = require("react");
const usePostHog = (apiKey, config, name) => {
    const router = router_1.useRouter();
    react_1.useEffect(() => {
        // Init PostHog
        posthog_js_1.default.init(apiKey, config, name);
        // Track page views
        const handleRouteChange = () => posthog_js_1.default.capture('$pageview');
        router.events.on('routeChangeComplete', handleRouteChange);
        return () => {
            router.events.off('routeChangeComplete', handleRouteChange);
        };
    }, []);
};
exports.usePostHog = usePostHog;
